/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const ChatMessageSenderRole = {
    User: 'User',
    Employer: 'Employer'
};
export function instanceOfChatMessageSenderRole(value) {
    for (const key in ChatMessageSenderRole) {
        if (Object.prototype.hasOwnProperty.call(ChatMessageSenderRole, key)) {
            if (ChatMessageSenderRole[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function ChatMessageSenderRoleFromJSON(json) {
    return ChatMessageSenderRoleFromJSONTyped(json, false);
}
export function ChatMessageSenderRoleFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ChatMessageSenderRoleToJSON(value) {
    return value;
}
export function ChatMessageSenderRoleToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
